import { useMemo } from 'react';
import styles from './Loader.module.css';
import { HeroIcon } from 'components/HeroIcon';

interface Properties {
  inverted?: boolean;
}

export const Loader = ({ inverted }: Properties) => {
  const classNames = useMemo(() => (inverted ? `${styles.loader} ${styles.inverted}` : styles.loader), [inverted]);
  return (
    <div className={classNames}>
      <HeroIcon icon="ArrowPathIcon" />
    </div>
  );
};
